<ion-header class="maintenance-header">
  <ion-toolbar color="primary">
    <ion-title class="ion-text-center"> Mantenimiento </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding maintenance-content">
  <div class="center-container">
    <!-- Ícono -->
    <ion-icon name="construct-outline" class="big-icon"></ion-icon>

    <!-- Texto principal -->
    <h2 class="main-title">Estamos en mantenimiento</h2>
    <p class="description">{{ window.message }}</p>

    <!-- Input para folio -->
    <ion-item lines="full" class="input-box">
      <ion-label position="floating">Folio</ion-label>
      <ion-input [(ngModel)]="codeInput" type="password" placeholder="•••••"> </ion-input>
    </ion-item>

    <!-- Mensaje de error -->
    <p *ngIf="error" class="error-message">
      {{ error }}
    </p>

    <!-- Botón -->
    <ion-button expand="block" shape="round" class="ion-margin-top" (click)="validateCode()"> Validar </ion-button>
  </div>
</ion-content>
